import { render, staticRenderFns } from "./DeveloperTools.vue?vue&type=template&id=7bfabdab&scoped=true"
import script from "./DeveloperTools.vue?vue&type=script&lang=js"
export * from "./DeveloperTools.vue?vue&type=script&lang=js"
import style0 from "./DeveloperTools.vue?vue&type=style&index=0&id=7bfabdab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfabdab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bfabdab')) {
      api.createRecord('7bfabdab', component.options)
    } else {
      api.reload('7bfabdab', component.options)
    }
    module.hot.accept("./DeveloperTools.vue?vue&type=template&id=7bfabdab&scoped=true", function () {
      api.rerender('7bfabdab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/DeveloperTools.vue"
export default component.exports